import { Badge } from '@mantine/core';

const STATUS_COLOR: Record<string, string> = {
    active: 'green',
    suspended: 'orange',
    deprovisioned: 'gray',
    staged: 'blue',
    recovery: 'yellow',
    unknown: 'gray',
};

export default function DirectoryStatusBadge({ status }: { status: string }) {
    return (
        <Badge size="xs" variant="light" color={STATUS_COLOR[status] ?? 'gray'}>
            {status}
        </Badge>
    );
}
